import { useEffect } from 'react';
import classNames from 'classnames';
import { QuestionnaireFormProps, QuestionnaireQuestions } from '../../models';

import styles from './Redirect.module.scss';

type RedirectProps<Questionnaire extends QuestionnaireQuestions> = {
  title: string;
  url: string;
  description?: string;
  showSpinner?: boolean;
  delay?: number;
} & QuestionnaireFormProps<Questionnaire>;

export const Redirect = <Questionnaire extends QuestionnaireQuestions>({
  title,
  url,
  description,
  showSpinner = false,
  delay = 300,
}: RedirectProps<Questionnaire>) => {
  useEffect(() => {
    const id = setTimeout(() => {
      window.location.href = url;
    }, delay);
    return () => {
      clearTimeout(id);
    };
  });
  return (
    <div
      className={classNames(
        'p-container d-flex fd-column ai-center jc-center',
        styles.container
      )}
    >
      {showSpinner && <div className="ds-spinner ds-spinner__l" />}
      <h1 className="p-h2 mt24 ta-center">{title}</h1>
      {description && (
        <div className={`p-p mt16 wmx7 ai-center ta-center jc-center`}>
          {description}
        </div>
      )}
    </div>
  );
};
